import { createApp } from 'vue';
import { createSlabViewerComponent } from './slabViewer';

/**
 * Mount using inline template from the DOM element (Petite Vue style)
 * The template is defined in the HTML, not in the JS component
 */
const mountInline = (selector = '#slab-viewer', props = {}) => {
    const element = document.querySelector(selector);
    if (!element) {
        console.warn(`Slab Viewer: Element with selector "${selector}" not found.`);
        return null;
    }

    // Get the template from the element's innerHTML
    const template = element.innerHTML.trim();
    
    // Create component with inline template
    const component = {
        ...createSlabViewerComponent(props),
        template: template || '<div>No template provided</div>'
    };

    const app = createApp(component);
    
    // Clear the element before mounting (Vue will replace it)
    element.innerHTML = '';
    
    app.mount(selector);
    return app;
};

// Auto-mount if the default selector exists
if (document.querySelector('#slab-viewer')) {   
    mountInline('#slab-viewer', window.slabViewerConfig || {});
}

window.initSlabViewerInline = mountInline;
